// notesThunk.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCoachNoteTopics, fetchCoachNotes, fetchAllCoachNotes, saveCoachNote, updateCoachNote, uploadAttachment, SaveNoteRequest } from "../../services/NotesService";

// Thunk to fetch coach notes for a user
export const fetchCoachNotesAsync = createAsyncThunk(
  "notes/fetchCoachNotes",
  async ({ userId, page = 1, perPage = 10 }: { userId: number; page?: number; perPage?: number }, { rejectWithValue }) => {
    try {
      const response = await fetchCoachNotes(userId, page, perPage);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to fetch coach note topics
export const fetchCoachNoteTopicsAsync = createAsyncThunk(
  "notes/fetchCoachNoteTopics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCoachNoteTopics();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to save a coach note
export const saveCoachNoteAsync = createAsyncThunk(
  "notes/saveCoachNote",
  async ({ noteData, userId }: { noteData: SaveNoteRequest, userId: string }, { rejectWithValue }) => {
    try {
      const response = await saveCoachNote(noteData, userId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to fetch all coach notes for a user (no pagination)
export const fetchAllCoachNotesAsync = createAsyncThunk(
  "notes/fetchAllCoachNotes",
  async (
    { userId, page = 1, perPage = 10 }: { userId: string; page?: number; perPage?: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchAllCoachNotes(userId, page, perPage);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to update an existing coach note
export const updateCoachNoteAsync = createAsyncThunk(
  "notes/updateCoachNote",
  async ({ noteData, userId, noteId }: { noteData: SaveNoteRequest, userId: string, noteId: number }, { rejectWithValue }) => {
    try {
      const response = await updateCoachNote(noteData, userId, noteId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to upload an attachment
export const uploadAttachmentAsync = createAsyncThunk(
  "notes/uploadAttachment",
  async (file: File, { rejectWithValue }) => {
    try {
      const response = await uploadAttachment(file);
      // Add the original file size and name to the response since API doesn't provide it
      return {
        ...response,
        size: file.size,
        name: file.name
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
